import bnBD from 'antd/locale/bn_BD';
import enUS from 'antd/locale/en_US';
import faIR from 'antd/locale/fa_IR';
import idID from 'antd/locale/id_ID';
import jaJP from 'antd/locale/ja_JP';
import ptBR from 'antd/locale/pt_BR';
import zhCN from 'antd/locale/zh_CN';
import zhTW from 'antd/locale/zh_TW';
import type { AppLocale } from './types';

export const antdLocales: Record<AppLocale, typeof zhCN> = {
  'bn-BD': bnBD,
  'en-US': enUS,
  'fa-IR': faIR,
  'id-ID': idID,
  'ja-JP': jaJP,
  'pt-BR': ptBR,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
};
